import { ChangeDetectorRef, Component, effect, DestroyRef, inject } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { RelationshipService } from 'src/app/shared/services/relationship/relationship.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LtmsLoaderComponent } from 'src/app/shared/components/ltms-loader/ltms-loader.component';
import {CustomerJourneyViewComponent} from '../customer-journey-view/customer-journey-view.component';
@Component({
    selector: 'app-customer-journey',
    standalone: true,
    templateUrl: './customer-journey.component.html',
    styleUrls: ['./customer-journey.component.scss'],
    imports: [NgFor, NgIf, LtmsLoaderComponent, CustomerJourneyViewComponent]
})
export class CustomerJourneyComponent {
    destroyRef = inject(DestroyRef) // Customer ID 1 is expanded by default
    viewType: string = 'listonly';
    customers: any = [];

    // Loading states
    isDataLoaded: boolean = false;
    isChartDataLoading: boolean = true;

    // No data flags
    isChartDataAvailable: boolean = false;


    /** Dummy data for the bar chart input */
    barChart: any = {
        labels: [],
        dataset: [],
        xText: 'Journey Stages',
        yText: 'Responses',
        showPercentage: false
    };
    chartConfig: any = {
        chartType: 'bar',
        stacked: false,
        useCustomConfig: true,
        stepSize: 20,
        minBarWidth: 30,
        min: -100,
        max: 100,
        data: {
            labels: [],
            datasets: []
        }
    }
    chartDataSets: any = {
        labels: [],
        datasets: [],
    };

    isDataLoading: boolean = true;
    selectedCustomerId: any = null;
    accountId: any = null;

    pagingDetails: any = {
        start: 0,
        end: 0,
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        totalpages: 1
    };
    pagingButtons: any = {
        isNext: false,
        isPrevious: false,
        isLast: false,
        isFirst: false
    };
    unique_field_id: any = null;
    unique_field_type: any = null;
    accountDetails: any = {};
    overallSummary: any = {};
    journeyConfig: any = {};


    selectedCustomer: any = null;
    constructor(private _stateService: AppStateService, private _relationshipService: RelationshipService, private cdr: ChangeDetectorRef) {
        effect(() => {
            this.isDataLoading = true;
            this.isChartDataLoading = true;
            const accountDetails: any = this._stateService.accountDetails();
            if (accountDetails && !_.isEmpty(accountDetails)) {
                this.accountId = accountDetails._id;
                this.accountDetails = accountDetails;
                this.unique_field_id = this._relationshipService.unique_field_id
                this.unique_field_type = this._relationshipService.unique_field_type
                if (this.accountId && this.journeyConfig && !_.isEmpty(this.journeyConfig)) {
                    this.getOverallSummary();
                }

            }
        });
        effect(() => {
            let journeyConfig: any = this._relationshipService.journeyConfig();
            if (journeyConfig && !_.isEmpty(journeyConfig)) {
                this.journeyConfig = Helpers.deepClone(journeyConfig)
                if (this.accountId && this.journeyConfig && !_.isEmpty(this.journeyConfig)) {
                    this.getOverallSummary();
                }
            }
        })
    }



    getOverallSummary() {
        let params: any = this.getQueryParams();
        this._relationshipService.getRelationshipOverallSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
            if (_.get(res, 'data.code') == 0 && _.get(res, 'data.summary') && !_.isEmpty(res?.data?.summary)) {
                const nps = this.getNPS(res.data.summary.total_responses, res.data.summary.promoter, res.data.summary.detractor);
                console.log(res.data.summary, 'res.data.summary');
                this.initPagingDetails(_.get(res, 'data.summary.repeated_user_count', 0));
                this.overallSummary = {
                    ...res.data.summary,
                    repeated_user_nps: nps
                };
            } else {
                this.initPagingDetails(0);
            }
        }, (error) => {
            console.error('Error fetching overall summary:', error);
            this.initPagingDetails(0);
        })
    }

    initPagingDetails(totalCustomers: number) {
        if (totalCustomers > 0) {
            this.pagingDetails.total = totalCustomers;
            this.pagingDetails.pageNumber = 1;
            this.pagingDetails.totalpages = Math.ceil(totalCustomers / this.pagingDetails.pageSize);
            this.pagingDetails.start = 1;
            this.pagingDetails.end = this.pagingDetails.pageSize;
            this.pagingButtons.isFirst = false;
            this.pagingButtons.isPrevious = false;
            this.pagingButtons.isNext = true;
            this.pagingButtons.isLast = true;
        } else {
            this.pagingDetails.total = 0;
            this.pagingDetails.pageNumber = 1;
            this.pagingDetails.totalpages = 1;
            this.pagingDetails.start = 0;
            this.pagingDetails.end = 0;
            this.pagingButtons.isFirst = false;
            this.pagingButtons.isPrevious = false;
            this.pagingButtons.isNext = false;
            this.pagingButtons.isLast = false;
        }
        this.getUsersList();

        this.cdr.detectChanges();
    }

    getUsersList() {
        this.isDataLoading = true;
        let params: any = this.getQueryParams();
        params.group_by = 'user';
        params.limit = this.pagingDetails.pageSize;
        params.page_number = this.pagingDetails.pageNumber;
        this._relationshipService.getRelationshipDetailedSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
            if (_.get(res, 'data.code') == 0 && _.has(res, 'data.summary') && !_.isEmpty(res.data.summary)) {
                this.customers = _.map(res.data.summary, (user: any) => {
                    return {
                        ...user,
                        id: user.user_id,
                        firstInteraction: moment(user.first_interaction).format('DD MMM \'YY HH:mm'),
                        lastInteraction: moment(user.last_interaction).format('DD MMM \'YY HH:mm'),
                        nps: this.getNPS(user.total_responses, user.promoter, user.detractor)
                    };
                });
            } else {
                this.customers = [];
            }
            this.isDataLoading = false;
            this.cdr.detectChanges();
        }, (error) => {
            console.error('Error fetching customer list:', error);
            this.customers = [];
            this.isDataLoading = false;
            this.cdr.detectChanges();
        });
    }



    paginateUserList(pagingType: string) {
        if (pagingType === 'next') {
            this.pagingDetails.pageNumber++;
        } else if (pagingType === 'previous') {
            this.pagingDetails.pageNumber--;
        } else if (pagingType === 'first') {
            this.pagingDetails.pageNumber = 1;
        } else if (pagingType === 'last') {
            this.pagingDetails.pageNumber = this.pagingDetails.totalpages;
        }
        this.updatePagingDetails();
        this.getUsersList();
        this.cdr.detectChanges();
    }

    updatePagingDetails() {
        this.pagingDetails.start = (this.pagingDetails.pageNumber - 1) * this.pagingDetails.pageSize + 1;
        this.pagingDetails.end = this.pagingDetails.pageNumber * this.pagingDetails.pageSize;
        if(this.pagingDetails.total <=  this.pagingDetails.end) {
            this.pagingDetails.end = this.pagingDetails.total;
        }
        this.pagingButtons.isFirst = this.pagingDetails.pageNumber > 1;
        this.pagingButtons.isPrevious = this.pagingDetails.pageNumber > 1;
        this.pagingButtons.isNext = this.pagingDetails.pageNumber < this.pagingDetails.totalpages;
        this.pagingButtons.isLast = this.pagingDetails.pageNumber < this.pagingDetails.totalpages;
    }



    getNPS(total: number, promoters: number, detractors: number) {
        if (total > 0) {
            return (((promoters / total) * 100) - ((detractors / total) * 100)).toFixed(0);
        }
        return "NA";
    }



    getQueryParams() {
        let query: any = {
            account_id: this.accountId,
            from: moment().subtract(2, 'year').format('YYYYMMDD'),
            to: moment().format('YYYYMMDD'),
            unique_field_id: this.unique_field_id,
            unique_field_type: this.unique_field_type
        }
        if (this._relationshipService.unique_field_id) {
            query.unique_field_id = this._relationshipService.unique_field_id
        }
        if (this._relationshipService.unique_field_type) {
            query.unique_field_type = this._relationshipService.unique_field_type
        }
        if (this._relationshipService.min_doc_count) {
            query.min_doc_count = this._relationshipService.min_doc_count
        }
        return query
    }


    openCustomerJourney(customer: any) {
        this.selectedCustomer = customer;
        this.selectedCustomerId = customer.id;
        this.cdr.detectChanges();
    }

    closeCustomerJourney() {
        this.selectedCustomer = null;
        this.selectedCustomerId = null;
        this.cdr.detectChanges();
    }
} 